export const DISTRICT_URL = "https://link.district.in/DSTRKT/ajywzs97";

export const FLYER_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_73e97f53-79cc-422b-b981-cb07dd7fce34/artifacts/b7c97d6fd5e25ea4_Hugel%20-%20Hero%20Image%20Landing.jpg";

export const VENUE_WIDE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/73e97f53-79cc-422b-b981-cb07dd7fce34/images/b7cf685c051f67f687805a406336b4508787d7ac5598ad59fc4099de845e00b2.jpeg";

export const VENUE_TALL_IMG =
  "https://static.prod-images.emergentagent.com/jobs/73e97f53-79cc-422b-b981-cb07dd7fce34/images/e09de02caeca42ca39433703e1d01b08974c586ee13dc7fc1843bcd217b9d537.jpeg";

const wa = (num, text) => `https://wa.me/${num}?text=${encodeURIComponent(text)}`;

export const WA = {
  tables1: wa("919991311399", "Hi, I'd like to enquire about a table for HUGEL Kolkata at RCTC, 25 Dec"),
  tables2: wa("916290452125", "Hi, I'd like to enquire about a table for HUGEL Kolkata at RCTC, 25 Dec"),
  lounge1: wa("917400777077", "Hi, I'd like to enquire about the Premium Lounge for HUGEL Kolkata, 25 Dec"),
  lounge2: wa("919776039776", "Hi, I'd like to enquire about the Premium Lounge for HUGEL Kolkata, 25 Dec"),
  offline: wa("918621864687", "Hi, I'd like to enquire about offline tickets for HUGEL Kolkata, 25 Dec"),
};
